import React, { useRef, useState, useEffect } from 'react';

export default function OTPInput({ length = 6, value, onChange, onComplete, disabled, autoFocus }) {
  const [digits, setDigits] = useState(Array(length).fill(''));
  const inputs = useRef([]);

  useEffect(() => {
    if (value && value.length === length && /^\d+$/.test(value)) {
      setDigits(value.split(''));
    }
  }, [value, length]);

  const handleChange = (idx, ch) => {
    if (!/^\d?$/.test(ch)) return;
    const next = [...digits];
    next[idx] = ch;
    setDigits(next);
    const joined = next.join('');
    onChange?.(joined);
    if (ch && idx < length - 1) {
      inputs.current[idx + 1]?.focus();
    }
    if (joined.length === length && !next.includes('')) {
      onComplete?.(joined);
    }
  };

  const handleKeyDown = (idx, e) => {
    if (e.key === 'Backspace' && !digits[idx] && idx > 0) {
      inputs.current[idx - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = (e.clipboardData.getData('text') || '').replace(/[^\d]/g, '').slice(0, length);
    if (!pasted) return;
    const next = Array(length).fill('');
    pasted.split('').forEach((c, i) => { next[i] = c; });
    setDigits(next);
    onChange?.(next.join(''));
    if (pasted.length === length) onComplete?.(pasted);
    inputs.current[Math.min(pasted.length, length - 1)]?.focus();
  };

  return (
    <div className="flex gap-2 justify-center">
      {Array(length).fill(0).map((_, idx) => (
        <input
          key={idx}
          ref={el => { inputs.current[idx] = el; }}
          type="text"
          inputMode="numeric"
          maxLength={1}
          autoComplete={idx === 0 ? 'one-time-code' : 'off'}
          autoFocus={autoFocus && idx === 0}
          disabled={disabled}
          value={digits[idx]}
          onChange={e => handleChange(idx, e.target.value)}
          onKeyDown={e => handleKeyDown(idx, e)}
          onPaste={idx === 0 ? handlePaste : undefined}
          className="w-12 h-14 text-center text-xl font-mono bg-[#0A0F1C] border border-[#22304A] rounded-lg text-white focus:border-[#3EF1C7] focus:outline-none"
        />
      ))}
    </div>
  );
}
